import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=7712dcfb"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"
import style0 from "./Verification.vue?vue&type=style&index=0&id=7712dcfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports